/**
 * Zvuková signalizace podle vrstvy (spec 9).
 *
 * V provozu je zvuk DŮLEŽITĚJŠÍ NEŽ BARVA: telefon bývá u pasu nebo v držáku,
 * barvu skladník uvidí jen když se podívá, zvuk slyší vždy.
 */
export type SoundProfile = 'go' | 'neutral' | 'stop' | 'edge';

let ctx: AudioContext | null = null;

/** AudioContext smí vzniknout až po uživatelské interakci (autoplay policy). */
export function primeAudio(): void {
  if (ctx) return;
  const Ctor = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (Ctor) ctx = new Ctor();
}

function tone(freq: number, ms: number, at: number, type: OscillatorType = 'sine'): void {
  if (!ctx) return;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, ctx.currentTime + at);
  gain.gain.exponentialRampToValueAtTime(0.35, ctx.currentTime + at + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + at + ms / 1000);
  osc.connect(gain).connect(ctx.destination);
  osc.start(ctx.currentTime + at);
  osc.stop(ctx.currentTime + at + ms / 1000 + 0.02);
}

export function playFeedback(profile: SoundProfile): void {
  primeAudio();
  if (ctx?.state === 'suspended') void ctx.resume();

  switch (profile) {
    case 'go':
      tone(980, 130, 0);
      vibrate(30);
      break;
    case 'neutral':
      tone(760, 130, 0);
      vibrate(30);
      break;
    case 'stop':
      // 3× ostrý tón – chyba musí být slyšet i přes hluk haly.
      tone(440, 150, 0, 'square');
      tone(440, 150, 0.22, 'square');
      tone(440, 150, 0.44, 'square');
      vibrate([90, 70, 90, 70, 160]);
      break;
    case 'edge':
      tone(680, 120, 0);
      tone(480, 160, 0.16);
      vibrate(30);
      break;
  }
}

/** `navigator.vibrate` funguje jen v Androidu/Chrome; na iOS Safari ne (spec 9). */
function vibrate(pattern: number | number[]): void {
  if (typeof navigator.vibrate === 'function') navigator.vibrate(pattern);
}
